/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IItemControllerHelper,
  IItemControllerHelperInterface,
} from "../IItemControllerHelper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "skillTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "skillTokenIds",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "areSkillsAvailableForHero",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAugmentationProtectiveItem",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "configId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "tokens",
        type: "uint256[][]",
      },
    ],
    name: "prepareToCombine",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IItemControllerHelper__factory {
  static readonly abi = _abi;
  static createInterface(): IItemControllerHelperInterface {
    return new Interface(_abi) as IItemControllerHelperInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IItemControllerHelper {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as IItemControllerHelper;
  }
}
